import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
import { accountActionsConfig } from '../../../helpers';
export const initialState = {
    config: accountActionsConfig,
    selectedAccountId: sessionStorage.getItem('selectedAccountId') ?? '',
    handleClose: () => null,
    authenticationRedirect: () => null
};
export const ConfigContext = createContext(initialState);
ConfigContext.displayName = 'ManageCardHolderContext';
export const useManageCardHolderContext = () => {
    const value = useContext(ConfigContext);
    if (!value) {
        throw new Error('No config');
    }
    return value;
};
const ConfigContextProvider = ({ state, children }) => {
    const updatedState = useMemo(() => state, [state]);
    return (_jsx(ConfigContext.Provider, { value: updatedState, children: children }));
};
export default ConfigContextProvider;
